export const renderParagraphsJson = (text: string) =>
  text.split('\n').map((p, i) => (
    <p key={'p' + i}>
      {p}
      <br />
    </p>
  ));
